import { worldToScreen, type Camera } from '@os/engine';
import { contrastRatio } from '../../ui/contrast';
import type { Peer } from './usePresence';

/** White on dark colours, near-black on light ones: the name stays readable on any peer colour (AA). */
const textOn = (bg: string) => (contrastRatio('#ffffff', bg) >= 4.5 ? '#ffffff' : '#141414');

/** Peers' cursors in screen space, each with the peer's name in their colour. */
export function RemoteCursors({ peers, camera }: { peers: readonly Peer[]; camera: Camera }) {
  return (
    <div aria-hidden="true" className="pointer-events-none absolute inset-0 z-10 overflow-hidden">
      {peers.map((p) => {
        if (!p.cursor) return null;
        const at = worldToScreen(camera, { x: p.cursor[0], y: p.cursor[1] });
        return (
          <div key={p.clientId} data-cursor className="absolute left-0 top-0" style={{ transform: `translate(${at.x}px, ${at.y}px)` }}>
            <svg width="16" height="20" viewBox="0 0 16 20">
              <path d="M1 1l13 8-6 1.5L5 18z" fill={p.user.c} stroke="#fff" strokeWidth="1.2" />
            </svg>
            <span className="ml-3 whitespace-nowrap rounded-full px-2 py-0.5 font-sans text-xs font-medium shadow-sm" style={{ background: p.user.c, color: textOn(p.user.c) }}>
              {p.user.n}
            </span>
          </div>
        );
      })}
    </div>
  );
}
